import { MUTATIONS } from '../../../storeConstants';

export default {
  [MUTATIONS.CHANGE](state, { target, value }) {
    state[target] = value;
  },
  //these are spilt out so that I can run specfic subscriptions on them
  // particualrly update payment data, which I do not want running on every 
  //mutation
  [MUTATIONS.CHANGE_INTEREST_RATE](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_EXTRA_MONTHLY_PAYMENT_AMOUNT](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_ANNUAL_PAYMENT_AMOUNT](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_ONE_TIME_PAYMENT_AMOUNT](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_ONE_TIME_PAYMENT_DATE](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_ANNUAL_PAYMENT_DATE](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_DOWNPAYMENT](state, { target, value }) {
    state[target] = value;
  },
  [MUTATIONS.CHANGE_MORTGAGE_START_DATE](state, { target, value }) {
    state[target] = value;
  },
};
